/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    CANCEL: 'Abbrechen',
    CONFIRM: 'Bestätigen',
    SAVE: 'Speichern',
    SEARCH: 'Suchen'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'E-mail',
    END_DATE: 'Enddatum',
    MEMBER_ID: 'Parter ID',
    NAME: 'Name'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Hinzufügen von Partnern zulassen',
    CREATE_MEMBER: 'Partner hinzufügen',
    DELETE_MEMBER_MODAL_TITLE: 'Partner löschen',
    EDIT_MEMBER: 'Partner bearbeiten',
    EMAIL: 'E-mail',
    END_DATE: 'Enddatum',
    MEMBERS: 'Partner',
    NAME: 'Name',
    NO: 'Nein',
    YES: 'Ja'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: 'Möchtest du diesen Partner wirklich löschen?',
    NO_MEMBER_NAME_EMAIL: 'Kein Name und/oder keine E-Mail',
    NO_MEMBER_NAME_EMAIL_DETAIL:
      'Bitte gib den Namen und/oder die E-Mail-Adresse an',
    NO_ROWS_MEMBERS: 'Keine Partner',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Bitte ändere deine Suchkriterien'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Partner wurde erfolgreich gelöscht.',
    MEMBER_DETAILS_SAVED: 'Partner wurde erfolgreich hinzugefügt.',
    SUCCESS: 'Erfolgreich'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Partner bearbeiten',
    EMAIL: 'E-mail',
    END_DATE: 'Enddatum',
    MEMBER_ID: 'Parter ID',
    NAME: 'Name',
    REMOVE_MEMBER: 'Partner löschen'
  }
};
